// src/com/trans_plan_bind/TransPlanBindGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * TRANS_PLAN_BIND Apollo Graphql
 * 운송요청 동적 배차내역
 * Project: NewTOP for cloud
 * 2025-02-24 18:00:15 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

/* const TRANS_PLAN_BIND_LIST_PART = gql`
fragment TransPlanBindListPart on TransPlanBind {
    bindGroupNo
    planDate
    comId
    vehInfoSeq
    vehPlates
    dcCd
    hocha
    useYn
    regUser
    regDate
    regUserName
}
`;

const TRANS_PLAN_BIND_NO_LIST_PART = gql`
fragment TransPlanBindNoListPart on TransPlanBind {
}
`;


export const LIST_TRANS_PLAN_BIND = gql`
${TRANS_PLAN_BIND_LIST_PART}
query ListTransPlanBind($bindGroupNo:Int!) {
    transPlanBindList(bindGroupNo:$bindGroupNo) {
        ...TransPlanBindListPart
    }
}
`;

export const GET_TRANS_PLAN_BIND = gql`
${TRANS_PLAN_BIND_LIST_PART}
${TRANS_PLAN_BIND_NO_LIST_PART}
query GetTransPlanBind($bindGroupNo:Int!) {
    transPlanBindItem(bindGroupNo:$bindGroupNo) {
        ...TransPlanBindListPart
        ...TransPlanBindNoListPart
    }
}
`; */

// {planId, planIdTwo}
export const ADD_TRANS_PLAN_BIND = gql`
mutation AddTransPlanBind($transPlanBind:InputTransPlanBindAdd!) {
	transPlanBindAdd(transPlanBind: $transPlanBind) {
		ok
		message
	}
}
`;

/* export const EDIT_TRANS_PLAN_BIND = gql`
mutation EditTransPlanBind($transPlanBind:InputTransPlanBindEdit!) {
	transPlanBindEdit(transPlanBind: $transPlanBind) {
		ok
		message
	}
}
`; */

// {bindGroupNo}
export const REMOVE_TRANS_PLAN_BIND = gql`
mutation RemoveTransPlanBind($transPlanBind:InputTransPlanBindRemove!) {
	transPlanBindRemove(transPlanBind: $transPlanBind) {
		ok
		message
	}
}
`;
